import { useParams, useSearchParams } from "react-router";
import { Trainer, type TrainMode } from "../components/Trainer";

/** §14.4 Train: the board is the hero; nothing else on the page. */
export function TrainPage({ mode }: { mode: TrainMode }) {
  const { id } = useParams();
  const [params] = useSearchParams();
  const theme = params.get("theme") ?? undefined;
  const retry = useParams().exerciseId;
  return (
    <main className="train">
      <Trainer key={`${mode}-${id ?? ""}-${theme ?? ""}`} mode={mode} moduleId={id ? Number(id) : undefined} theme={theme} retryExercise={retry ? Number(retry) : undefined} />
    </main>
  );
}
